import React, { useEffect, useState } from 'react'
import { CustomModal } from '../../../../components'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { getDeliveriesAssociadasBip } from '../../../../services/api/https/picking/picking.http'

export default function TabBipsFaltantesModal({ visible, onClose, item, pickingId }) {
  const [deliveries, setDeliveries] = useState([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (visible && item && item.product_code && item.area_name) {
      buscarDeliveriesAssociadas()
    }
  }, [visible, item])

  const buscarDeliveriesAssociadas = async () => {
    try {
      setLoading(true)
      const response = await getDeliveriesAssociadasBip(pickingId, item.product_code, item.area_name)
      setDeliveries(response || [])
    } catch (error) {
      console.error('Erro ao buscar deliveries associadas:', error)
      setDeliveries([])
    } finally {
      setLoading(false)
    }
  }

  // Render
  return (
    <CustomModal onClose={onClose} isVisible={visible} header={'Notas Associadas'}>
      <div className="p-grid" style={{ maxWidth: 800, maxHeight: '80vh', overflowY: 'auto' }}>
        <div className="p-col-12">
          {loading ? (
            <div style={{ textAlign: 'center', padding: '20px' }}>Carregando...</div>
          ) : (
            <DataTable
              value={deliveries}
              emptyMessage="Nenhuma nota associada"
              paginator={deliveries.length > 5}
              rows={5}
              style={{ fontSize: '0.9em' }}
            >
              <Column field="nota" header="Nota" style={{ width: '30%' }} />
              <Column field="nomeFantasia" header="Nome Fantasia" style={{ width: '45%' }} />
              <Column field="cidade" header="Cidade" style={{ width: '25%' }} />
            </DataTable>
          )}
        </div>
      </div>
    </CustomModal>
  )
}
